export default __webpack_public_path__ + "static/media/ftc.452049f4.jfif";